import classes from './Image.module.css';

function Image(props) {
	return (
		<picture>
			{(typeof(props.filename_webp) !== "undefined" && props.filename_webp !== null) ? <source srcSet={"https://poolsupplies.nyc3.cdn.digitaloceanspaces.com/media/webp/" + props.filename_webp} type="image/webp" /> : ""}
			<source srcSet={props.filename !== null ? "https://poolsupplies.nyc3.cdn.digitaloceanspaces.com/media/" + props.filename : "https://poolsupplies.nyc3.cdn.digitaloceanspaces.com/media/image-not-available.png"}  type={"image/" + props.filetype} />
			<img className={classes.img} src={props.filename !== null ? "https://poolsupplies.nyc3.cdn.digitaloceanspaces.com/media/" + props.filename : "https://poolsupplies.nyc3.cdn.digitaloceanspaces.com/media/image-not-available.png"} alt={props.name} />
		</picture>
	);
}

export default Image;